import { __rest } from '/Users/gimboseog/development/moim-frontend/node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { Wrapper } from './styled.mjs';
export { default as PositionChip } from './preset/positionChip/index.mjs';

var ChipBase = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var shape = _a.shape,
    size = _a.size,
    overrideStyle = _a.overrideStyle,
    className = _a.className,
    selected = _a.selected,
    children = _a.children,
    onClick = _a.onClick,
    rest = __rest(_a, ["shape", "size", "overrideStyle", "className", "selected", "children", "onClick"]);
  var refThis = React.useRef(null);
  React.useImperativeHandle(ref, function () {
    return {
      self: refThis
    };
  });
  return jsx(Wrapper, Object.assign({
    role: onClick ? "button" : undefined,
    ref: refThis,
    tabIndex: 0,
    "data-selected": Boolean(selected),
    shape: shape,
    size: size,
    overrideStyle: overrideStyle,
    className: className,
    onClick: onClick
  }, rest, {
    children: children
  }));
});

export { ChipBase };
